define('viewmodels/modals/dialogs/ForgotPasswordDialog',['knockout'], function (ko) {

    var ForgotPasswordDialog = function(dialog, forgotPasswordModel, formFields, getField, username) {
        var self = this;

        // prepoulate username
        forgotPasswordModel.emailOrCasumoName(username || '');

        self.field = formFields.casumoNameField( forgotPasswordModel.emailOrCasumoName );

        self.title = getField('forgot_password_title');
        self.instructionsText = getField('forgot_password_instructions');
        self.fieldLabel = getField('forgot_password_field_label');
        self.successMessage = getField('forgot_password_success_message');
        self.closeButtonText = getField('forgot_password_close_button_text');

        self.dialog = dialog;

        self.emailSent = ko.observable(false);

        self.forgotPasswordCommand = forgotPasswordModel.createCommand(function() {
            self.emailSent(true);
            self.forgotPasswordCommand.reset();
        });
    };

    ForgotPasswordDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return ForgotPasswordDialog;
});

